import Vue from 'vue'
import filters from './filters'
import methods from './methods'

export default Vue.mixin({ filters, methods })
